/**
 * Layout tokens — keep in sync with `src/app/globals.css` (`--container-max`,
 * `--container-max-2xl`) and Tailwind `--breakpoint-2xl` (96rem).
 */

/** Default content column — Figma 1280 within 1440 artboard. */
export const CONTAINER_MAX_REM = 80;

/**
 * Large-desktop chart-section column (2xl+). At 1920 with 80px gutters this
 * fills the viewport so filter chrome can sit on the gutter edge instead of
 * in a centred 1280 band.
 */
export const CONTAINER_MAX_2XL_REM = 110;

/** Red List Index plate — Figma graph 723px. */
export const RED_LIST_INDEX_MAX_WIDTH_REM = 45.1875;

/**
 * Centred middle chart area within wide chart sections (Chord, RLI at 2xl+).
 */
export const CHART_AREA_MAX_WIDTH_REM = 45;

/** @deprecated Prefer `CHART_AREA_MAX_WIDTH_REM` — RLI 2xl plate alias. */
export const RED_LIST_INDEX_MAX_WIDTH_2XL_REM = CHART_AREA_MAX_WIDTH_REM;
